/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_PrivacyInputs */

const en_directory_footer_link_privacy = /** @type {(inputs: Directory_Footer_Link_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy`)
};

const zh_directory_footer_link_privacy = /** @type {(inputs: Directory_Footer_Link_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐私政策`)
};

/**
* | output |
* | --- |
* | "Privacy" |
*
* @param {Directory_Footer_Link_PrivacyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_privacy = /** @type {((inputs?: Directory_Footer_Link_PrivacyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_PrivacyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_privacy(inputs)
	return zh_directory_footer_link_privacy(inputs)
});
export { directory_footer_link_privacy as "directory.footer.link_privacy" }